<template>
    <button class="button button_view_icon button_theme_base mtb__-4"
            :disabled="disabled"
            @click.stop="goToUnitTrack"
    >
        <span class="icon">
            <span class="icon__symbol">
                <SvgIcon class="icon" name="common__track" />
            </span>
        </span>
    </button>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'UnitsList_unit_menu_edit',
        mixins: [],
        props: {
            unitId: Number,
            disabled: Boolean,
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                "getDateToday",
            ]),
        },
        methods: {
            goToUnitTrack(){
                this.setRoute.track(this.$route, this.$router, this.unitId, this.getDateToday)
            },
        },
    }
</script>